import { useCallback, useEffect, useSyncExternalStore } from 'react';

import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import { defaultLandingPageStore } from 'modules/Authentication/utils/defaultLandingPageStore';
import { LandingSection } from 'modules/Authentication/utils/setDefaultLandingPage';

/**
 * React binding for `defaultLandingPageStore`. The hook is intentionally thin:
 * - `useSyncExternalStore` keeps the component re-rendered when the store changes.
 * - The effect triggers hydration on mount (and on `matrixClient` identity change).
 * - `setPreference` is a stable callback that delegates to the store.
 */
const useDefaultLandingPagePreference = () => {
  const { matrixClient } = useMatrixContext();

  const state = useSyncExternalStore(defaultLandingPageStore.subscribe, defaultLandingPageStore.getSnapshot);

  useEffect(() => {
    defaultLandingPageStore.hydrate(matrixClient);
  }, [matrixClient]);

  const setPreference = useCallback(
    (section: LandingSection) => defaultLandingPageStore.set(matrixClient, section),
    [matrixClient]
  );

  return {
    preference: state.preference,
    isHydrated: state.isHydrated,
    setPreference,
  };
};

export default useDefaultLandingPagePreference;
